(function (angular) {


    angular.module('app').directive('body', body);

    function body() {
        return {
            restrict: 'E',
            link: function (scope, $element) {
                $element.on('click', 'a[href=#]', function (e) {
                    e.preventDefault();
                });

                if ($('body').hasClass('mobile')) {
                    var elements = 'input[type="text"],input[type="password"],input[type="date"],input[type="number"],input[type="email"],select,textarea';
                    $element.on('focusin', elements, function (e) {
                        $('body').addClass('keyboardOpen');
                    });
                    $element.on('focusout', elements, function (e) {
                        $('body').removeClass('keyboardOpen');
                    });
                }
            }
        }
    }

})(angular);